<template>
  <Form v-if="load" :customTable="customTable"/>
</template>

<script>
  import Form from '@/components/admin/custom_tables/Form'
  import ModelMapper from '@/mixins/ModelMapper'
  import { mapMutations } from 'vuex'

  export default {
    components: { Form },
    created() {
      this.asyncTemplateShow(this.id, {
        after: ({model}) => {
          this.customTable = model
          this.setNameBreadcrumb(model.name)
          this.load = true
        }
      })
    },
    data() {
      return {
        customTable: {},
        load: false,
        modelPathPrefix: 'admin',
        nameModel: 'CustomTable'
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
    },
    mixins: [ModelMapper],
    name: 'Show',
    props: ['id']
  }
</script>

<style scoped>

</style>